module.exports = __webpack_public_path__ + "img/CertificateOfHonor01.23b250a1.png";